import Patients from "../Patients";

export default function NextVisits() {
  return (
    <>
      <Patients heading={"Next Visits"} />
    </>
  );
}
